










































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";

class PagegroupBuyRecordRequest extends PageRequest {
  id: number = null;
}

@Component({
  components: {},
})
export default class membershipRecords extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: null }) id: number | null;

  pagerequest: PagegroupBuyRecordRequest = new PagegroupBuyRecordRequest();
  membershipId: number = null;
  get list() {
    console.log(
      this.$store.state.membership.recordList,
      "this.$store.state.membership.recordList"
    );
    return this.$store.state.membership.recordList;
  }

  get loading() {
    return this.$store.state.membership.loading;
  }
  pageChange(page: number) {
    this.$store.commit("membership/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("membership/setPageSize", pagesize);
    this.getpage();
  }
  // search() {
  //   this.$store.commit("joinGroupBuyRecord/setCurrentPage", 1);
  //   this.getpage();
  // }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "membership/getAllListByMembershipId",
      data: this.pagerequest,
    });
  }
  save() {
    this.$emit("input", false);
  }
  get pageSize() {
    return this.$store.state.membership.pageSize;
  }
  get totalCount() {
    return this.$store.state.membership.totalCount;
  }
  get currentPage() {
    return this.$store.state.membership.currentPage;
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      if (this.id) {
        this.pagerequest.id = this.id;
        this.$store.commit("membership/setCurrentPage", 1);
        await this.$store.dispatch({
          type: "membership/getAllListByMembershipId",
          data: this.pagerequest,
        });
      }
    }
  }
  columns = [
    {
      title: "球会名称",
      key: "courtName",
    },
    {
      title: "联系人",
      key: "linkMan",
    },
    {
      title: "联系人手机号",
      key: "phoneNumber",
    },
    {
      title: "种类",
      key: "category",
    },
    {
      title: "预期价格",
      key: "price",
    },
    {
      title: "买入/卖出",
      key: "tradeType",
      render: (h: any, params: any) => {
        return h("span", params.row.tradeType == 0 ? "卖出" : "买入");
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
  ];
}
